import { reactive } from "#imports";
import { createSharedComposable } from "@vueuse/core";
import { UiIconName } from "../icon/index.js";
import { getIconName } from "../icon/iconNameTemplate.js";
export const usePortalBranding = createSharedComposable(() => {
  const branding = reactive({
    logo: getIconName(UiIconName.Logo),
    logoFull: getIconName(UiIconName.LogoFull),
    slogan: ""
  });
  function clean() {
    branding.logo = "";
    branding.logoFull = "";
    branding.slogan = "";
  }
  return {
    branding,
    clean
  };
});
